import { useTranslation } from 'react-i18next';

import { RequestFinalScreen } from 'components';

const CreditCardRequestExistsPage = () => {
  const { t } = useTranslation();

  return (
    <RequestFinalScreen
      title={t('card.request.exists.title')}
      description={t('card.request.exists.description')}
    />
  )
}

export default CreditCardRequestExistsPage;